module.exports = __webpack_public_path__ + "static/img/Alonso.182fc9c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Alonso.jpg
// module id = OZIZ
// module chunks = 1